
    const path = "/psh/config.js";
    const script = document.createElement('script');
    script.type= "text/javascript";
    script.src = path;
    script.onload= () => {
        console.log("psh config is loaded");
    }
    document.head.appendChild(script);
// }

const path2 = "/psh/DragDropTouch.js";
    const script2 = document.createElement('script');
    script2.type= "text/javascript";
    script2.src = path2;
    script2.onload= () => {
        console.log("psh config is loaded");
    }
    document.head.appendChild(script2);


export const loadConfig= "none"